<div class="header">
  <div class="title">Change Status</div>
  <button class="close-button" mat-icon-button (click)="discard()" [tabIndex]="-1">
    <mat-icon [svgIcon]="'close'"></mat-icon>
  </button>
</div>

<form>
  <mat-form-field class="flex-auto gt-xs:pr-3">
    <mat-label>What do you want to change the status to?</mat-label>
    <mat-select (selectionChange)="stageChange($event)">
      <mat-option *ngFor="let projectStage of projectStages" [value]="projectStage.id">
        {{ projectStage.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  @if (requiredFields$ | async; as requiredFields) {
    @if (requiredFields.length) {
      <p class="mb-4">The following fields are required in order to change the status.</p>
      @for (fieldDef of requiredFields; track fieldDef.name) {
        <app-form-field [fieldDef]="fieldDef" [model]="project" [data]="data.data" class="w-full"></app-form-field>
      }
    }
  }

  @if (invalidDeals | async; as deals) {
    @if (deals.length) {
      <div>
        <p class="mb-2 mb-2 text-red-550">
          The following deals are invalid because their views don't allow the selected status.
        </p>
        @for (deal of deals; track deal.id) {
          <p class="ml-2">
            <strong>{{ deal.title }}</strong> (View: <span class="italic">{{ deal.pipeline_name }}</span
            >)
          </p>
        }
      </div>
    }
  }

  <div class="actions justify-end">
    <div class="buttons">
      <button class="discard-button" mat-button (click)="discard()" type="button">
        <span>Cancel</span>
      </button>
      <button
        class="send-button"
        mat-flat-button
        [color]="'primary'"
        type="submit"
        #btnFocus="matButton"
        [disabled]="!stageId || isLoading || (invalidDeals | async).length > 0"
        (click)="save()"
      >
        @if (!isLoading) {
          Save
        } @else {
          <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
        }
      </button>
    </div>
  </div>
</form>
